var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* eslint react/prop-types: 0 */
import React, { useState, useEffect } from 'react';
import * as R from 'ramda';
import { getHierarchicalId } from './utils';

var withExpansionTree = function withExpansionTree(Component) {
  return function (_ref) {
    var items = _ref.items,
        defaultExpandedIds = _ref.defaultExpandedIds,
        rest = _objectWithoutProperties(_ref, ['items', 'defaultExpandedIds']);

    var _useState = useState({}),
        expandedIds = _useState[0],
        setExpandedIds = _useState[1];

    var _useState2 = useState([]),
        itemsIds = _useState2[0],
        setItemsIds = _useState2[1];

    useEffect(function () {
      var ids = R.map(getHierarchicalId, items);
      if (!R.isEmpty(R.symmetricDifference(ids, itemsIds))) setItemsIds(ids);
    }, [items]);

    useEffect(function () {
      setExpandedIds(R.indexBy(R.identity, itemsIds));
    }, [itemsIds]);

    useEffect(function () {
      if (!R.isNil(defaultExpandedIds)) {
        setExpandedIds(defaultExpandedIds);
      }
    }, [defaultExpandedIds]);

    var expand = function expand(id) {
      setExpandedIds(R.assoc(id, id, expandedIds));
    };

    var collapse = function collapse(id) {
      setExpandedIds(R.dissoc(id, expandedIds));
    };

    var expandAll = function expandAll() {
      setExpandedIds(R.indexBy(R.identity, itemsIds));
    };

    var collapseAll = function collapseAll() {
      setExpandedIds({});
    };

    return React.createElement(Component, _extends({}, rest, {
      items: items,
      expand: expand,
      collapse: collapse,
      expandAll: expandAll,
      collapseAll: collapseAll,
      expandedIds: expandedIds
    }));
  };
};
export { withExpansionTree };